@if (variant === 'dateRange') {
  <mat-form-field [class.disable-hint]="disableHint"
                  [class.with-label]="label"
                  [class.readonly]="readonly"
                  [class.readonly--no-borders]="readonlyNoBorders"
                  [style.max-width]="maxWidth + 'px'"
                  appearance="outline"
                  class="work-ui-input-datepicker"
                  floatLabel="always">
    @if (label) {
      <mat-label>{{ label | translate }}</mat-label>
    }
    <mat-date-range-input [dateFilter]="dateFilter"
                          [disabled]="disabled"
                          [formGroup]="rangeDateForm"
                          [rangePicker]="rangePicker"
                          [required]="required">
      <input #startDateInput
             (dateInput)="handleRangeDateChange($event.value, 'startDate')"
             (input)="onRangeInput($event, 'startDate')"
             [formControlName]="rangeStartDateFormControlName"
             [placeholder]="(rangeStartDatePlaceholder || 'STARTDATUM' | translate)"
             matStartDate data-testid="input-datepicker__start-date-input">
      <input #endDateInput
             (dateInput)="handleRangeDateChange($event.value, 'endDate')"
             (input)="onRangeInput($event, 'endDate')"
             [formControlName]="rangeEndDateFormControlName"
             [placeholder]="( rangeEndDatePlaceholder || 'ENDDATUM' | translate)"
             matEndDate data-testid="input-datepicker__end-date-input">
    </mat-date-range-input>
    @if (!rangeDateForm.untouched && rangeDateForm.invalid) {
      <mat-error>
        @if (rangeDateForm.controls[rangeStartDateFormControlName].hasError('required') || rangeDateForm.controls[rangeEndDateFormControlName].hasError('required')) {
          <span>{{ 'FELD_DARF_NICHT_LEER_SEIN' | translate }}</span>
        }
        @if (rangeDateForm.controls[rangeStartDateFormControlName].hasError('invalidDate') || rangeDateForm.controls[rangeEndDateFormControlName].hasError('invalidDate')) {
          <span>{{ 'UNGUELTIGES_DATUMSFORMAT' | translate }}</span>
        }
      </mat-error>
    }
    <mat-datepicker-toggle [for]="rangePicker" [disabled]="disabled" matIconSuffix />
    <mat-date-range-picker #rangePicker />
  </mat-form-field>
} @else {
  <mat-form-field [class.disable-hint]="disableHint"
                  [class.with-label]="label"
                  [class.readonly]="readonly"
                  [class.readonly--no-borders]="readonlyNoBorders"
                  [style.max-width]="maxWidth + 'px'"
                  appearance="outline"
                  class="work-ui-input-datepicker"
                  floatLabel="always">
    @if (label) {
      <mat-label>{{ label | translate }}</mat-label>
    }
    <input #singleDateInput
           (dateChange)="onDateSingleChange($event)"
           (input)="onInput($event)"
           [formControl]="singleDateFormControl"
           [matDatepickerFilter]="dateFilter"
           [matDatepicker]="picker"
           [placeholder]="singleDatePlaceholder | translate"
           [required]="required"
           [value]="singleDate"
           matInput
           data-testid="input-datepicker__single-input">
    @if (!singleDateFormControl.untouched && singleDateFormControl.invalid) {
      <mat-error>
        @if (singleDateFormControl.hasError('required')) {
          <span>{{ 'FELD_DARF_NICHT_LEER_SEIN' | translate }}</span>
        }
        @if (singleDateFormControl.hasError('invalidDate')) {
          <span>{{ 'UNGUELTIGES_DATUMSFORMAT' | translate }}</span>
        }
      </mat-error>
    }
    <mat-datepicker-toggle [for]="picker" [disabled]="disabled" matIconSuffix />
    <mat-datepicker #picker />
  </mat-form-field>
}
